import PropTypes from 'prop-types';
import { matchPath } from 'react-router-dom';
import { List } from '@mui/material';
import NavItem from './NavItem';
import { useLocation } from 'react-router';

const renderNavItems = ({ location, title, _children, path, pathPrefix = '', _partialMatch, icon, info }) => {
  const _path = pathPrefix + path;
  const exactMatch = path
    ? !!matchPath({ path, end: true }, location.pathname)
    : false;

  return (
    <NavItem
      key={`NavItem-${title}`}
      icon={icon}
      info={info}
      title={title}
      path={_path.replace('//', '/')}
      active={_partialMatch || exactMatch}
    >
      {_children?.length > 0 &&
        _children
          .filter(x => x.title)
          .map(child => {
            const partialMatch = child.path
              ? !!matchPath({ path: child.path, end: false }, location.pathname)
              : false;
            return renderNavItems({
              location,
              title: child.title,
              _children: child._children,
              path: child.path,
              pathPrefix: path,
              _partialMatch: partialMatch,
              icon: child.icon,
            });
          })}
    </NavItem>
  );
};

const NavSection = ({ title, path, _children, icon, info }) => {
  const location = useLocation();

  return (
    <List disablePadding>
      {renderNavItems({ location, title, _children, path, icon, info })}
    </List>
  );
};

NavSection.propTypes = {
  title: PropTypes.string,
  path: PropTypes.string,
  _children: PropTypes.array,
  icon: PropTypes.node,
  info: PropTypes.node,
};

export default NavSection;
